module.exports = __webpack_public_path__ + "static/media/antonio_egydio_sao_tiago_graca.ba52aeb2.jpg";